import script from "./ReadingStreakNotification16464.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReadingStreakNotification16464.vue?vue&type=script&setup=true&lang=ts"

import "./ReadingStreakNotification16464.vue?vue&type=style&index=0&id=a1e4a52a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1e4a52a"]])

export default __exports__